/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.custom.enrichment.rpc.client.SmartPropertyStatusService
 */

export let ComHubspotCustomEnrichmentModels;
(function (_ComHubspotCustomEnrichmentModels) {})(ComHubspotCustomEnrichmentModels || (ComHubspotCustomEnrichmentModels = {}));
export let ComHubspotCustomEnrichmentModelsPropertyStatuses;
(function (_ComHubspotCustomEnrichmentModelsPropertyStatuses) {})(ComHubspotCustomEnrichmentModelsPropertyStatuses || (ComHubspotCustomEnrichmentModelsPropertyStatuses = {}));
/**
 *  Represents a batch response for smart property statuses.
 *  <p>The outer key is the objectId, and the inner key is the property name.</p>
 */
export const getSmartPropertyBatchRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.SmartPropertyStatusService',
  rpcName: 'getSmartPropertyBatch',
  auth: 'app',
  fingerprint: 'gKaM-Ge2wTK5hca_0nMyFRy7eWMKXE8Z',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};